// extracted by mini-css-extract-plugin
module.exports = {"Container":"CopyToClipboardWrapper_Container__187oa","Url":"CopyToClipboardWrapper_Url__1_Pa8","BtnWrapper":"CopyToClipboardWrapper_BtnWrapper__3-Vur"};